<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1"><a id="page_iii"></a><strong>PRESCRIBED</strong></h1>
<p class="subtitle"><em>Writing, Filling, Using, and Abusing the Prescription in Modern America</em></p>
<p class="author"><em>Edited by</em><br/>Jeremy A. Greene<br/>     <em>and</em><br/>Elizabeth Siegel Watkins</p>
<p class="publisher"><img alt="image" src="images/pub.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?79516d8c